module.exports = __webpack_public_path__ + "static/img/DALE-SUTHERLAND.00b1c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DALE-SUTHERLAND.jpg
// module id = Lih7
// module chunks = 0